import React from "react";
import { Navigate, useParams } from "react-router-dom";
import CarteModule from "../components/CarteModule";
import { GROUPES, estVisible, modulesVisibles } from "../modulesV2";

// ===================================================================
// The Crowd v2 — Page de regroupement
//
// Une seule page pour Mon activite, Gestion utilisateurs et Pilotage :
// le contenu vient de GROUPES (modulesV2.js), selon l'identifiant de
// l'URL (/v2/<groupeId>). Un regroupement inconnu ou non visible pour
// ce role renvoie a l'accueil.
//
// Sert aussi aux modules a sous-cartes (ex. Comptes AD) : la coque passe
// alors le module en prop `groupe`, qui remplace la lecture de l'URL.
// ===================================================================

function GroupeV2({ collaborateur, onOuvrirModule, groupe: groupeImpose }) {
  const { groupeId } = useParams();
  const groupe = groupeImpose || GROUPES[groupeId];

  if (!groupe || !estVisible(groupe, collaborateur)) {
    return <Navigate to="/v2" replace />;
  }

  const modules = modulesVisibles(groupe, collaborateur);

  return (
    <div className="v2-page">
      <section className="v2-entete v2-entete-groupe">
        <span className="v2-entete-icone" aria-hidden="true">
          <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d={groupe.icone} />
          </svg>
        </span>
        <div>
          <h1 className="v2-titre">{groupe.titre}</h1>
          <p className="v2-sous-titre">{groupe.description}</p>
        </div>
      </section>

      <div className="v2-grille v2-grille-groupe">
        {modules.map((m) => (
          <CarteModule
            key={m.id}
            titre={m.titre}
            description={m.description}
            icone={m.icone}
            aCadrer={!!m.aCadrer}
            onClick={() => onOuvrirModule(m)}
          />
        ))}
      </div>
    </div>
  );
}

export default GroupeV2;
